import React from 'react'
import { format } from 'date-fns'

const UnavailabilityDates = ({ appraiserInfo }) => {
  const { fetching, error, unavailableDates } = appraiserInfo
  
  return (
    <div className='unavailability-dates'>
      <h3>Latest Unavailability History</h3>
      {fetching && <div>Loading...</div>}
      {!error && !fetching && unavailableDates.length < 1 && <div>No unavailability dates on record.</div>}
      {!error && !fetching && unavailableDates.map(date =>
        <>
          <table key={date.id}>
            <tbody>
              <tr>
                <th scope='row'>Unavailable Dates</th>
                <td>{date.unavailableFromDate &&
                  `${format(date.unavailableFromDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}–${format(date.unavailableToDate, 'MM/dd/yyyy', { awareOfUnicodeTokens: true })}`}</td>
              </tr>
              <tr>
                <th scope='row'>Reason for Unavailability</th>
                <td>{date.appraiserUnavailiabityReasonType}</td>
              </tr>
              <tr>
                <th scope='row'>Unavailability Notes</th>
                <td>{date.unavailableReason}</td>
              </tr>
              <tr>
                <th scope='row'>Requested by Appraiser</th>
                <td>{date.unavailableRequestedBy === 'Y' ? 'Yes' : date.unavailableRequestedBy === 'N' ? 'No' : ''}</td>
              </tr>
            </tbody>
          </table>
          <br />
        </>)}
      {error && !fetching &&
        <div className='appraiser-error'>Error: Unable to load unavailability dates.</div>}
    </div>
  )
}
export default UnavailabilityDates